/*jslint node: true, browser: true*/
"use strict";

var createBreadcrumbs = require("pli/breadcrumbs");
var ko = require("pli/knockout");
var pli = require("pli/forms");
var viewModelInit = require("pli/forms-viewmodel");

var createFileViewModel = require("../filestore").fileViewModel;
var createReportCriteriaViewModel = require("./reportCriteriaViewModel");
var createUploadViewModelExtras = require("../filestore").uploadViewModelExtras;
var dataCache = require("../datacache");
var entityRegistry = require("../entity-registry");

require("../geoschema");

//---------------------------------------
viewModelInit.enableSlideTransitions();

//-------------------------------------------
function getReportTypeFromUrl() {
    var pathArray = window.location.pathname.split("/"),
        id = pathArray[pathArray.length - 1];

    return id;
}

//-------------------------------------------
function getReportDescription(reportsData, reportType, o) {
    var result,
        data = reportsData.data;

    if (!data || !data.items) {
        return;
    }

    result = ko.utils.arrayFirst(data.items, function (item) {
        return item.type === reportType;
    });

    if (result && result.description) {
        o(result.description);
    }
}

//-------------------------------------------
function getReportTitle(reportsData, reportType, o) {
    var result,
        data = reportsData.data;

    if (!data || !data.items) {
        return;
    }

    result = ko.utils.arrayFirst(data.items, function (item) {
        return item.type === reportType;
    });

    if (result && result.name) {
        o(result.name);
    }
}

//---------------------------------------
function setReportHeaderInfo(reportType, titleObservable, descriptionObservable) {
    var reports = dataCache.get("reports"),
        exports = dataCache.get("exports"),
        imports = dataCache.get("imports");

    reports.done(function (reportsData) {
        getReportTitle(reportsData, reportType, titleObservable);
        getReportDescription(reportsData, reportType, descriptionObservable);
    });

    exports.done(function (reportsData) {
        getReportTitle(reportsData, reportType, titleObservable);
        getReportDescription(reportsData, reportType, descriptionObservable);
    });

    imports.done(function (reportsData) {
        getReportTitle(reportsData, reportType, titleObservable);
        getReportDescription(reportsData, reportType, descriptionObservable);
    });
}


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//---------------------------------------
viewModelInit.createRoot = function createReportForm() {
    var viewModelRoot,
        factories,
        entityViewModelCreator = createReportCriteriaViewModel;

    if (typeof entityViewModelCreator !== "function") {
        throw new Error("Required method createReportCriteriaViewModel is not defined");
    }

    if (!entityViewModelCreator.viewModelPrototype) {
        throw new Error("Required property createReportCriteriaViewModel.viewModelPrototype is not defined");
    }

    //--------------------------------------------------
    //  Closes window (if it was open by window.open)
    entityViewModelCreator.viewModelPrototype.close = function reportFormClose() {
        window.close();
    };

    entityViewModelCreator.viewModelPrototype.closeMessage = function reportCloseHeaderMessage() {
        viewModelRoot.extras.isHeaderMessageVisible(false);
    };

    //---------------------------------------
    // Duplicate this saved report.
    entityViewModelCreator.viewModelPrototype.duplicate = function reportDuplicate() {
        viewModelRoot.extras.state("busy.duplicate");
        viewModelRoot.guid(null);

        viewModelRoot.extras.rootData.id = '';
        location.hash = '';
        viewModelRoot.id("DUPLICATE OF " + viewModelRoot.id());

        // select the name field, but do it in just a moment to give the UI a chance to update first
        setTimeout(function afterDuplicate() {
            viewModelRoot.extras.state("ready.dirty");
            viewModelRoot.extras.isEditable(true);
            pli.forms.crumbs.peek().begin.page.findActivationFocus().focus().select();
        }, 400);

        return false;
    };

    //---------------------------------------
    // Show help for this document.
    entityViewModelCreator.viewModelPrototype.help = function reportFormHelp() {
        entityRegistry.help.show();
        return false;
    };

    //---------------------------------------
    // Goes to the root of the form.
    entityViewModelCreator.viewModelPrototype.home = function reportHome() {
        location.hash = pli.forms.crumbs().begin.hash;
        return false;
    };

    //---------------------------------------
    entityViewModelCreator.viewModelPrototype.loaded = function reportFormLoaded(record) {
        // If report is 'Custom Export' or 'Well Import', make the UI non editable (ie Disable Save button)
        // Reason: they are one off reports that don't need to be saved
        if (this.reportType === "CustomExport" || this.reportType === "WellImport") {
            this.extras.isEditable(false);
            this.extras.isHeaderMessageVisible(false);
        } else {
            ko.postbox.publish("state.isEditable", (record ? record.editable : true));
            this.extras.isHeaderMessageVisible(record ? !record.editable : false);
        }

        this.loadViewModel(record);
    };

    //---------------------------------------
    entityViewModelCreator.viewModelPrototype.up = function moveUpReportHierarchy() {
        var c = pli.forms.crumbs().end;
        if (c.previous && c.previous.hash) {
            location.hash = c.previous.hash;
        }
        return false;
    };

    //--------------------------------------------------
    entityViewModelCreator.viewModelPrototype._computeDirtyState = function reportFormComputeDirtyState() {
        var s = this.extras.state();
        if (s === "ready" || s === "ready.saved") {
            if (this.extras.dirty()) {
                this.extras.state("ready.dirty");
            }
        }
    };

    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._computeDuplicateStateMessage = function computeDuplicateStateMessage() {
        if (this.extras.state() === "busy.duplicate") {
            return { message: "Duplicating", stateIndicationClass: "fileDuplicating" };
        }
        return { message: "Duplicate", stateIndicationClass: "noChanges" };
    };

    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._computeReadOnly = function computereportFormReadOnly() {
        return !this.extras.isEditable() || this.extras.state().indexOf("ready") !== 0;
    };

    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._computeReady = function computeDocumentReady() {
        return this.extras.state().indexOf("ready") === 0;
    };

    //---------------------------------------
    // Compute and set tool tip for Save button
    entityViewModelCreator.viewModelPrototype._computeSaveButtonToolTip = function computeSaveButtonToolTip() {
        if (this.extras.state().indexOf('.failed') === -1) {
            return "Save all changes to this report (Ctrl+S)";
        }

        return "";
    };

    //---------------------------------------
    entityViewModelCreator.viewModelPrototype.showErrorList = function showErrorList() {
        return false;
    };

    //---------------------------------------
    entityViewModelCreator.viewModelPrototype.moveOutErrorList = function moveOutErrorList() {
        return false;
    };

    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._computeSaveStateMessage = function computereportFormSaveStateMessage() {
        switch (this.extras.state()) {
        case "busy.saving":
            return { message: "Saving", stateIndicationClass: "fileSaving" };
        case "ready.saved":
            return { message: "Saved", stateIndicationClass: "fileSaved" };
        default:
            return { message: "Save", stateIndicationClass: "noChanges" };
        }
    };

    //---------------------------------------
    entityViewModelCreator.viewModelPrototype._computeWarningState = function computeWarningState() {
        var s = this.extras.state();
        if (s) {
            s = s.replace(".failed", "");
            if (s.indexOf("ready") === 0) {
                if (this.extras.errorsCount && this.extras.errorsCount() > 0) {
                    this.extras.state(s + ".failed");
                } else {
                    this.extras.state(s);
                    this.extras.isErrorListVisible(false); // explicit hiding error list menu
                }
            }
        }
    };

    //---------------------------------------
    // Hide tooltip list
    entityViewModelCreator.viewModelPrototype._hideErrorList = function hideErrorList() {
        this.extras.isErrorListVisible(false);
        return true; // allow event propagation & default handling
    };

    //---------------------------------------
    /*jslint unparam: true*/
    entityViewModelCreator.viewModelPrototype._safeSaving = function reportFormSafeSaving(data, e) {
        if (e && e.stopImmediatePropagation) {
            e.stopImmediatePropagation(); // prevent hiding the tool tip while it showing by click on Save button
        }

        // Check if viewModel has errors before saving then showing tooltip list
        if (this.extras.errorsCount && this.extras.errorsCount() === 0) {
            this.save();
        }

        return false; // stop propagation & default (if keyboard event)
    };
    /*jslint unparam: false*/


    //--------------------------------------
    // Show notification error panel in case if viewModel state is "failed" and errors count is 0 (unknown server-side error)
    // or show error list tooltip if errors count isn't 0 (known server-side error)
    entityViewModelCreator.viewModelPrototype._showErrorPanelAfterSaving = function showErrorPanelAfterSaving() {
        var s = this.extras.state(), p = this.extras.prevState();
        if ((s === "ready.failed" || s === "ready.saved.failed" || s === "ready.dirty.failed") && p === "busy.saving") {
            if (this.extras.errorsCount() === 0) {
                this.extras.notificationErrorPanel.show({
                    title: "Save failed",
                    message: "Unexpected save error"
                });
            }

            this.extras.prevState(s); // reset previous state observable
        }
    };

    //--------------------------------------
    // Computes if a report is dirty
    // "Custom Export" and "Well Import" are not saved so their "dirty" is always false
    entityViewModelCreator.viewModelPrototype._computeReportDirty = function computeReportDirty() {
        return this.extras.dirty() && this.reportType !== "CustomExport" && this.reportType !== "WellImport";
    };

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ViewModel initialization
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    //--------------------------------------------------
    viewModelInit.onViewModelCreated(function onreportFormCreated(viewModel, viewModelInit) {
        viewModel.extras.dirty = ko.dirtyFlag(viewModel, true, true); // create suspended
        viewModel.extras.isReportDirty = ko.computed(viewModel._computeReportDirty, viewModel);
        viewModel.extras.breadcrumbs = createBreadcrumbs(pli.forms.crumbs);
        viewModel.extras.isEditable = ko.observable().subscribeTo("state.isEditable");
        viewModel.extras.isHeaderMessageVisible = ko.observable(false).subscribeTo("state.isEditable");
        viewModel.extras.isReadOnly = ko.computed(viewModel._computeReadOnly, viewModel);
        viewModel.extras.isReadOnly.publishOn("state.isReadOnly");
        viewModel.extras.isReady = ko.computed(viewModel._computeReady, viewModel);
        viewModel.extras.isReady.publishOn("state.isReady");
        viewModel.extras.saveButtonTooltip = ko.computed(viewModel._computeSaveButtonToolTip, viewModel);

        viewModel.extras.prevState = ko.observable(viewModel.extras.state());
        viewModel.extras.state.subscribe(function (oldValue) {
            viewModel.extras.prevState(oldValue);
        }, viewModel, "beforeChange");

        viewModel.extras.isErrorListVisible = ko.observable(false);
        viewModel.extras.suppressBusyIndicator = true;
        viewModel.extras.saveStateMessage = ko.computed(viewModel._computeSaveStateMessage, viewModel);
        viewModel.extras.duplicateStateMessage = ko.computed(viewModel._computeDuplicateStateMessage, viewModel);

        viewModel.hideErrorList = viewModel._hideErrorList.bind(viewModel);
        viewModel.safeSaving = viewModel._safeSaving.bind(viewModel);

        ko.computed(viewModel._computeDirtyState, viewModel);
        ko.computed(viewModel._computeWarningState, viewModel);
        ko.computed(viewModel._showErrorPanelAfterSaving, viewModel);
        ko.computed(function () {
            // Load parameters from query string if any
            if (viewModel.extras.state() === "ready" && window.location.search.length > 1) {
                viewModel._loadCriteriasFromQueryString(window.location.search.substring(1));
            }
        }, viewModel);

        viewModelInit.defaultKeymap = ko.utils.extend(
            ko.utils.extend({}, pli.config.defaultKeymap),
            {
                "Back": viewModel.up,
                "Close": viewModel.close,
                "Help": viewModel.help,
                "Home": viewModel.home,
                "Save": viewModel.safeSaving,
                "Duplicate": viewModel.duplicate
            }
        );
    });

    factories = {
        main: viewModelInit.createMainViewModel,
        advanced: viewModelInit.createAdvancedViewModel,
        loadWidgetRecord: viewModelInit.loadWidgetRecord,
        createUploadExtras: createUploadViewModelExtras,
        createFileViewModel: createFileViewModel,
        computeErrorsCount: viewModelInit.computeErrorsCount,
        createFactory: viewModelInit.createGridViewModelFactory,
        setReportHeaderInfo: setReportHeaderInfo,
        getReportType: getReportTypeFromUrl
    };

    viewModelRoot = entityViewModelCreator(factories);

    // define methods for dialog registry
    pli.dialogClosingMessage = function computeReportClosingMessage() {
        return (viewModelRoot.extras.isReportDirty()
            ? "This report has unsaved changes"
            : null);
    };
    pli.dialogId = function computeDocumentId() {
        return "reports-" + factories.getReportType() + "-" + viewModelRoot.id();
    };

    return viewModelRoot;
};



//////////////////
// WEBPACK FOOTER
// ./app/report/reportForm.js
// module id = 501
// module chunks = 49